<template>
  <div id="contact-form" class="contact-form-component">
    <div class="contact-form">
      <div class="container mt-5 mb-5">
        <div class="row">
        <div class="col-12">
          <div class="contact-text mt-3">
            Feel free to reach out with <br />
            any questions or suggestions!
          </div>
        </div>
      </div>
      <div class="row mt-5">
        <div class="col-lg-6">
          <div class="contact-image" v-show="media.isDesktop"></div>
        </div>
        <div class="col-12 col-lg-6">
          <form id="send-email" class="send-email" @submit.prevent="submit">
            <div class="form-group">
              <input
                type="text"
                name="name"
                id="name"
                class="form-control"
                v-model="name"
              />
              <label for="name">Name</label>
              <div class="text-danger" :class="!name ? 'visible' : 'invisible'">
                Your name is required
              </div>
            </div>
            <div class="form-group">
              <input
                type="text"
                name="company"
                id="company"
                class="form-control"
                v-model="company"
              />
              <label for="company">Company Name (For Resellers Only)</label>
            </div>
            <div class="form-group">
              <input
                type="email"
                name="email"
                id="email"
                class="form-control"
                v-model="email"
              />
              <label for="email">Email</label>
              <div class="text-danger" :class="!email ? 'visible' : 'invisible'">
                Your email is required
              </div>
            </div>
            <div class="form-group">
              <textarea
                name="contents"
                id="message"
                cols="30"
                rows="10"
                class="form-control"
                v-model="message"
              ></textarea>
              <label for="contents">Message</label>
              <div class="text-danger" :class="!message ? 'visible' : 'invisible'">
                Your message is required
              </div>
            </div>
            <div
              class="p-3 mb-2 text-white"
              :class="success ? 'bg-success' : 'bg-danger'"
              v-show="responseMessage"
              v-html="responseMessage"
            >
            </div>
            <div class="form-group">  
               <vue-recaptcha
                  ref="recaptcha"
                  @verify="onVerify"
                  @expired="onExpired"
                  size="invisible"
                  :sitekey="sitekey">
                </vue-recaptcha>
              <button
                class="btn btn-dutche btn-lg"
                :class="!media.isDesktop ? 'btn-block' : ''"
                :disabled="sending"
              >
                <i class="fas fa-spinner fa-spin" v-show="sending"></i>
                <span class="font-weight-bold"> {{ sendButton }}</span>
              </button>
            </div>
          </form>
        </div>
      </div>
      </div>
      <div class="row">
        <div class="col-12">
          <div class="contact-image" v-show="!media.isDesktop"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
 import VueRecaptcha from 'vue-recaptcha';

export default {
  name: "ContactForm",
  components: {
    VueRecaptcha
  },
  data() {
    return {
      name: null,
      email: null,
      message: null,
      company: null,
      sending: false,
      responseMessage: null,
      success: false,
      token: null,
      sitekey: process.env.VUE_APP_RECAPTCHA_SITE_KEY,
    };
  },
  mounted() {
    const recaptchaScript = document.createElement('script')
    recaptchaScript.setAttribute('src', 'https://www.google.com/recaptcha/api.js?onload=vueRecaptchaApiLoaded&render=explicit')
    document.head.appendChild(recaptchaScript)
  },
  computed: {
    sendButton() {
        if (this.sending) {
          return 'Sending';
        } else {
          return 'Send';
        }
    },
    media() {
      return {
        "isDesktop": this.$screen.lg
      };
    }
  },
  methods: {
    submit() {
      this.$refs.recaptcha.execute();
    },
    onVerify(response) {
      this.token = response;
      this.responseMessage = '';
      this.sending = true;
      this.send();
    },
    onExpired() {
      this.$refs.recaptcha.reset();
    },
    send() {
      axios.post("/send-email", {
        name: this.name,
        email: this.email,
        company: this.company,
        contents: this.message,
        token: this.token
      }).then(response => {
        this.sending = false;
        if (response.data.success) {
          this.success = true;
        }
        this.responseMessage = response.data.message;
      }).catch(error => {
        this.sending = false;
        if (error.response.status !== 422) {
         this.responseMessage = 'Something went wrong, please try again';
         return;
        }

        const { name, email, contents } = error.response.data.errors;

        if (name !== undefined) {
          this.responseMessage = `${name[0]} <br>`
        }

        if (email !== undefined) {
          this.responseMessage += `${email[0]} <br>`
        }

        if (contents !== undefined) {
          this.responseMessage += `${contents[0]}`
        }
      });
    }
  }
};
</script>

<style lang="sass" scoped>
.contact-form
  .contact-text
    font-size: 2.5em
    font-family: "Might Could"
    text-align: center

  .send-email .form-control
    border-top: none
    border-left: none
    border-right: none
    background-color: inherit
    border-radius: 0
    border-color: $dutche-quaternary-violet

  .send-email label
    text-transform: uppercase
    font-weight: bold

  .btn-dutche
    text-transform: uppercase
    border-radius: 0.5rem
    background-color: $dutche-primary-violet
    color: $white

.contact-image
    background: url('../../assets/images/contact/contact.png')
    background-size: cover
    background-position: center
    height: 750px
    width: auto

@media (min-width: 992px)
  .contact-form
    .contact-text
      text-align: left

    .btn-dutche
      width: 20rem

  .contact-image
      height: 100%
</style>
